<app-spinner-service></app-spinner-service>

<div class="dashboard-main-grid">
  <div class="dashboard-calendar-row">
    <app-dashboard-calendar></app-dashboard-calendar>
  </div>
  <div class="dashboard-kpis-row-fixed">
    <ng-container *ngIf="kpis$ | async as kpis">
      <app-kpi-card *ngFor="let kpi of kpis" [title]="kpi.title" [value]="kpi.value" [icon]="kpi.icon" [color]="kpi.color"></app-kpi-card>
    </ng-container>
  </div>

  <div class="dashboard-charts-single-row">
    <ng-container *ngIf="chartData$ | async as chartData">
      <app-dashboard-chart [title]="'Evolução Financeira Mensal (Baseado em Extratos Importados)'" [type]="'bar'" [data]="chartData"></app-dashboard-chart>
    </ng-container>
    <ng-container *ngIf="receitasPorCliente$ | async as receitasPorCliente">
      <app-dashboard-chart [title]="'Receitas por Cliente (NFS-e)'" [type]="'pie'" [data]="receitasPorCliente"></app-dashboard-chart>
    </ng-container>

  </div>
</div>

<div class="full-width-tutorial-faq">
  <app-tutorial-faq></app-tutorial-faq>
</div>

<style>
.dashboard-grid {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.dashboard-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
}
</style>
